// Whether a proxy is picked for browser jobs (public.proxies.status). Written only
// by core (a job failed through it) and core-cron (its recheck), never by a cabinet
// save, so the Proxies grid shows it read-only.
export const PROXY_STATUS = ['active', 'failed'];
